export default "/images/vendor/flag-icon-css/flags/1x1/es-ga.svg?405f191245cb5d0085d789f338a16d67";